import { sendErrorMetric } from "@expert/cloudwatch-metrics";
import type { SalesChecklistSection } from "@expert/contentful";
import { getLogger } from "@expert/logging";
import { ErrorBoundary } from "react-error-boundary";
import { ChecklistSection } from "./ChecklistSection";
import { ChecklistSectionFallback } from "./OfferChecklistFallbacks";

interface ChecklistSectionWrapperProps {
    section: SalesChecklistSection;
    onSectionComplete: (title: string) => void;
}

const logger = getLogger({
    module: "ChecklistSectionWithErrorBoundary",
    supportTeam: "sales",
});

export function ChecklistSectionWithErrorBoundary({ section, onSectionComplete }: ChecklistSectionWrapperProps) {
    return (
        <ErrorBoundary
            onError={(error) => {
                logger.error(`Error rendering offer checklist section: ${error}`);
                void sendErrorMetric("OfferChecklistError", { eventSource: "Offer-Checklist" });
            }}
            fallbackRender={() => <ChecklistSectionFallback section={section} />}
        >
            <ChecklistSection section={section} onSectionComplete={onSectionComplete} />
        </ErrorBoundary>
    );
}
